import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import MbSelectbox from 'components/molecules/MbSelectbox';

const ManagerFilter = ({
  label,
  value,
  name,
  getParam,
  params,
  handleGetManager,
  style,
}) => {
  const { t } = useTranslation();
  const { contactMenus } = useSelector(({ common }) => ({
    contactMenus: common.contactMenus,
  }));
  const [managerParams, setManagerParams] = useState(params);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (JSON.stringify(params) !== JSON.stringify(managerParams)) {
      setManagerParams({ ...params });
      handleGetManager({ ...params });
      if (
        typeof managerParams.contact === 'number' &&
        typeof params.content === 'undefined'
      ) {
        setIndex(0);
      }
    }
    // eslint-disable-next-line
  }, [params]);

  /**
   * 영업 담당자 필터 선택
   * @param {string} name
   * @param {*} value
   */
  const handleFilterChange = (name, index, value) => {
    let newParams;
    newParams = {
      ...managerParams,
      [name]: value,
    };
    setManagerParams(newParams);
    setIndex(index);
    getParam(newParams);
    handleGetManager({ ...newParams });
  };
  return (
    <MbSelectbox
      label={typeof label === 'undefined' ? t('담당자') : label}
      value={value}
      itemindex={index}
      name={name}
      optionData={contactMenus}
      optionLabelKey="CONTACT_NAME"
      optionValueKey="CONTACT_NO"
      handleOnchange={handleFilterChange}
      icon={false}
      style={style}
    />
  );
};

export default ManagerFilter;
